const testimonials = [
  {
    result: 'ROAS 15배',
    period: '4개월',
    before: '월 매출 4.8억',
    after: '월 매출 20.1억',
    growth: '+318%',
    name: '김민준',
    role: 'CEO · 패션 이커머스',
    quote: '4개월 만에 매출 4배, 광고비는 그대로였습니다.\n성과가 이렇게 달라질 수 있다는 걸 처음 알았어요.',
    avatar: 'https://public.readdy.ai/ai/img_res/3af054a4ce8f4a285bbb22694af8c1a9.jpg',
  },
  {
    result: 'CPA -60%',
    period: '3개월',
    before: 'CPA 18,000원',
    after: 'CPA 7,200원',
    growth: '-60%',
    name: '박서연',
    role: '마케팅 디렉터 · 뷰티 D2C',
    quote: '대행사 3곳을 비교했지만 데이터 분석 수준이 달랐습니다.\n매주 전략 리포트를 받으니 신뢰가 생겼어요.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Korean%20female%20marketing%20director%20portrait%20clean%20background%20confident%20modern%20corporate%20headshot%20smart&width=64&height=64&seq=tm2f&orientation=squarish',
  },
  {
    result: '구글 월 2억+',
    period: '6개월',
    before: '구글 매출 0',
    after: '구글 월 2억+',
    growth: '신규 채널',
    name: '이정호',
    role: '대표 · 건강기능식품',
    quote: '구글 광고 A-Z를 다 설명해주더니 6개월 만에 월 2억.\n예상을 훨씬 뛰어넘는 결과였습니다.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Korean%20male%20entrepreneur%20portrait%20studio%20clean%20background%20confident%20smile%20modern%20business%20headshot&width=64&height=64&seq=tm3f&orientation=squarish',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-10 md:py-20 bg-[#07091A]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">

        {/* Header */}
        <div className="mb-7 md:mb-10">
          <p className="text-neon text-xs md:text-sm font-bold mb-2.5 tracking-widest uppercase leading-relaxed">고객 후기</p>
          <div className="flex flex-col sm:flex-row sm:items-end gap-2 sm:gap-6">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white font-display leading-tight">
              실제 성과가 말해줍니다
            </h2>
            <div className="flex items-center gap-2 sm:pb-1.5">
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-neon text-xs md:text-sm"></i>
                ))}
              </div>
              <span className="text-white/50 text-xs md:text-sm">350개 브랜드 평균 별점 4.9</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-7 md:mb-10">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#0D1025] border border-white/6 rounded-2xl hover:border-neon/25 transition-all duration-300 flex flex-col">
              {/* Result header */}
              <div className="bg-neon/8 border-b border-neon/15 px-5 md:px-6 py-5 md:py-6">
                <div className="flex items-start justify-between mb-3 md:mb-4">
                  <div>
                    <div className="text-2xl md:text-3xl font-black text-neon font-display leading-none">{t.result}</div>
                    <div className="text-white/40 text-xs md:text-sm mt-1.5 leading-relaxed">{t.period} 만에 달성</div>
                  </div>
                  <div className="bg-neon/15 border border-neon/25 rounded-lg px-2.5 py-1.5">
                    <span className="text-neon font-black text-sm leading-none">{t.growth}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-white/30 line-through text-xs leading-relaxed">{t.before}</span>
                  <i className="ri-arrow-right-line text-neon text-xs flex-shrink-0"></i>
                  <span className="text-neon font-bold text-xs md:text-sm leading-relaxed">{t.after}</span>
                </div>
              </div>

              {/* Quote + author */}
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-0.5 mb-3.5 md:mb-4">
                  {Array.from({ length: 5 }).map((_, si) => (
                    <i key={si} className="ri-star-fill text-neon text-xs md:text-sm"></i>
                  ))}
                </div>
                <p className="text-white/65 text-sm md:text-base leading-[1.85] md:leading-[2] italic flex-1 mb-5 md:mb-6 break-words">
                  &ldquo;{t.quote.split('\n').map((line, li) => (
                    <span key={li}>
                      {li > 0 && <br className="hidden md:block" />}
                      {line}
                    </span>
                  ))}&rdquo;
                </p>
                <div className="flex items-center gap-3 border-t border-white/5 pt-4">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover object-top flex-shrink-0" />
                  <div>
                    <div className="text-white font-bold text-sm md:text-base leading-snug">{t.name}</div>
                    <div className="text-white/35 text-xs md:text-sm mt-0.5 leading-relaxed">{t.role}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Industry tags */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-2 mb-7 md:mb-10">
          {['패션', '뷰티', '건강', '음식', '교육', '여행', '홈리빙', '스포츠', 'SaaS', 'B2B'].map((tag) => (
            <span key={tag} className="px-3 md:px-4 py-1.5 md:py-1.5 bg-white/3 border border-white/7 rounded-full text-white/35 text-xs whitespace-nowrap leading-relaxed">
              {tag}
            </span>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            className="inline-flex items-center gap-2 md:gap-3 bg-neon hover:bg-neon-dim text-navy font-black px-8 md:px-12 py-4 md:py-5 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap text-base md:text-lg w-full sm:w-auto justify-center"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            지금 무료로 광고 진단 받기
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </button>
          <p className="text-white/25 text-xs md:text-sm mt-3.5 leading-relaxed">
            상담 비용 0원 · 계약 강요 없음<br className="block md:hidden" />· 24H 응답
          </p>
        </div>
      </div>
    </section>
  );
}
